(() => {
  if (window.__appstleMixMatchSkinLoaded) {
    return;
  }

  window.__appstleMixMatchSkinLoaded = true;

  const PACKS = [
    { count: 2, label: '2 Pack', badge: 'Save 15%' },
    { count: 3, label: '3 Pack', badge: 'Save 20%' },
    { count: 4, label: '4 Pack', badge: 'Save 25%' }
  ];
  const SUBSCRIPTION_DEFAULT_OPTIONS = {
    'template-product-2-pack': 'bundle 15',
    'template-product-3-pack': 'bundle 20',
    'template-product-4-pack': 'bundle 25'
  };
  const ONE_TIME_DISCOUNT_AMOUNT = 10;
  const bundlePageSettings = window.KROWN?.settings?.bundle_page || {};
  const productRatings = bundlePageSettings.products || {};
  const catalogueTabs = Array.isArray(bundlePageSettings.catalogue_tabs) ? bundlePageSettings.catalogue_tabs : [];
  const oneTimeDiscountCodes = bundlePageSettings.one_time_discount_codes || {};

  let appstleRoot = null;
  let panel = null;
  let toolbar = null;
  let observer = null;
  let isRendering = false;
  let isSyncingRatings = false;
  let activeCatalogueFilter = 'all';
  let activeSearchTerm = '';
  let catalogueToolbarSignature = '';
  let activePackLimit = 2;
  let selectedItemsCount = 0;
  let purchaseMode = 'onetime';
  let frozenChoicePrices = null;
  let pendingChoicePrices = null;
  let choicePriceTimer = null;
  let wasSubscribeSelected = false;
  const baseProductPrices = new Map();

  const textOf = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim();

  const parseMoney = (value) => {
    const match = String(value || '').replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  };

  const formatMoney = (value) => {
    if (!Number.isFinite(value) || value <= 0) {
      return '';
    }

    const roundedValue = Math.round(value * 100) / 100;
    const formattedValue = roundedValue % 1 === 0 ? String(roundedValue) : roundedValue.toFixed(2);

    return `$${formattedValue}`;
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const getBackgroundImage = (node) => {
    if (!(node instanceof HTMLElement)) {
      return '';
    }

    const image = window.getComputedStyle(node).backgroundImage;
    const match = image.match(/url\(["']?(.*?)["']?\)/);
    return match ? match[1] : '';
  };

  const getProductHandleFromUrl = (url) => {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const parts = parsedUrl.pathname.split('/').filter(Boolean);
      const productsIndex = parts.indexOf('products');

      return productsIndex >= 0 ? (parts[productsIndex + 1] || '') : '';
    } catch (error) {
      const match = String(url || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  };

  const getProductItemHandle = (item) => {
    const link = item?.querySelector?.('.ab-mix-and-match-product-title[href]');
    return getProductHandleFromUrl(link?.getAttribute('href') || '');
  };

  const normalizeFilterValue = (value) => {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  };

  const normalizeRatingValue = (value) => {
    if (value && typeof value === 'object') {
      return Number(value.rating || value.value || 0);
    }

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Number(parsed?.rating || parsed?.value || value || 0);
      } catch (error) {
        return Number(value || 0);
      }
    }

    return Number(value || 0);
  };

  const normalizeColor = (value) => {
    const color = String(value || '').trim();

    return /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)
      || /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i.test(color)
      ? color
      : '';
  };

  const getRatingData = (handle) => productRatings[handle];

  const getProductBackgroundColor = (handle) => {
    const productId = getRatingData(handle)?.id;

    return normalizeColor(window.bundle_color?.[productId]);
  };

  const buildRatingMarkup = (handle) => {
    const ratingData = getRatingData(handle);
    const rating = normalizeRatingValue(ratingData?.rating);
    const count = Number(ratingData?.count || 0);

    if (!rating || !count) {
      return '';
    }

    const fullStars = rating >= 5 ? 5 : Math.max(Math.floor(rating), 0);
    const hasHalfStar = rating < 5;
    const emptyStars = Math.max(5 - fullStars - (hasHalfStar ? 1 : 0), 0);
    const stars = [
      ...Array(fullStars).fill('<span class="ab-byob-product-rating__star ab-byob-product-rating__star--full">&#9733;</span>'),
      ...(hasHalfStar ? ['<span class="ab-byob-product-rating__star ab-byob-product-rating__star--half">&#9733;</span>'] : []),
      ...Array(emptyStars).fill('<span class="ab-byob-product-rating__star ab-byob-product-rating__star--empty">&#9733;</span>')
    ].join('');

    return `
      <span class="ab-byob-product-rating__stars" aria-label="Rating ${escapeHtml(rating.toFixed(1))} out of 5">${stars}</span>
      <span class="ab-byob-product-rating__count">(${escapeHtml(count)})</span>
    `;
  };

  const getRatingKey = (handle) => {
    const ratingData = getRatingData(handle);
    const rating = normalizeRatingValue(ratingData?.rating);
    const count = Number(ratingData?.count || 0);

    return rating && count ? `${handle}|${rating.toFixed(1)}|${count}` : '';
  };

  const syncProductRatings = () => {
    if (isSyncingRatings) {
      return;
    }

    isSyncingRatings = true;

    try {
      const productItems = Array.from(appstleRoot?.querySelectorAll('.ab-mix-and-match-product-item') || []);

      productItems.forEach((item) => {
        const title = item.querySelector('.ab-mix-and-match-product-title');
        const handle = getProductItemHandle(item);
        const ratingData = getRatingData(handle);
        const ratingKey = getRatingKey(handle);
        const ratingMarkup = buildRatingMarkup(handle);
        let ratingNode = item.querySelector('.ab-byob-product-rating');

        item.dataset.searchText = textOf(title);

        if (ratingData?.catalogue) {
          item.dataset.catalogue = ratingData.catalogue;
          item.dataset.catalogueFilter = normalizeFilterValue(ratingData.catalogue);
          title?.setAttribute('data-catalogue-label', ratingData.catalogue);
        }

        const card = item.querySelector('.ab-mix-and-match-product-card');
        const backgroundColor = getProductBackgroundColor(handle)
          || normalizeColor(card?.style.backgroundColor)
          || normalizeColor(window.getComputedStyle(card).backgroundColor);

        if (backgroundColor) {
          item.dataset.bundleColor = backgroundColor;
          item.style.setProperty('background-color', backgroundColor, 'important');
          card?.style.setProperty('background-color', backgroundColor);
          item.querySelectorAll('.ab-mix-and-match-selected-variants-list').forEach((list) => {
            list.style.setProperty('background-color', backgroundColor, 'important');
          });
        }

        if (!ratingMarkup) {
          ratingNode?.remove();
          return;
        }

        if (!ratingNode) {
          ratingNode = document.createElement('div');
          ratingNode.className = 'ab-byob-product-rating';
          title?.insertAdjacentElement('afterend', ratingNode);
        }

        if (ratingNode.dataset.ratingKey !== ratingKey) {
          ratingNode.innerHTML = ratingMarkup;
          ratingNode.dataset.ratingKey = ratingKey;
        }
      });

      renderCatalogueTabs();
      applyCatalogueFilter();
    } finally {
      isSyncingRatings = false;
    }
  };

  const getProductKey = (product) => `${product.title}|${product.image}`;

  const getStableProductPrice = (product) => {
    const key = getProductKey(product);
    const cachedPrice = baseProductPrices.get(key) || 0;
    const currentPrice = product.price || 0;
    const stablePrice = Math.max(cachedPrice, currentPrice);

    if (stablePrice > 0) {
      baseProductPrices.set(key, stablePrice);
    }

    return stablePrice;
  };

  const findRoot = () => document.querySelector('.ab-mix-and-match-container');

  const normalizeBundleUrl = (value) => {
    const url = String(value || '').trim();

    if (!url) {
      return '';
    }

    if (/^(https?:)?\/\//i.test(url) || url.startsWith('/')) {
      return url;
    }

    return `/products/${url}`;
  };

  const getBundlePackLinks = () => PACKS.map((pack, index) => {
    const settingsKey = `bundle_pack_${index + 1}`;
    const url = normalizeBundleUrl(bundlePageSettings[settingsKey]);

    return {
      ...pack,
      url
    };
  }).filter((pack) => pack.url);

  const isActiveUrl = (url) => {
    if (!url) {
      return false;
    }

    try {
      const targetUrl = new URL(url, window.location.origin);
      const targetPath = targetUrl.pathname.replace(/\/$/, '');
      const currentPath = window.location.pathname.replace(/\/$/, '');
      return targetUrl.href === window.location.href || targetPath === currentPath;
    } catch (error) {
      return url === window.location.href || url === window.location.pathname;
    }
  };

  const getTemplatePackCount = () => {
    const bodyClass = document.body?.className || '';
    const match = bodyClass.match(/template-product-([234])-pack/);

    return match ? Number(match[1]) : 0;
  };

  const getActivePackCount = (selectedCount, bundlePackLinks) => {
    const activeLink = bundlePackLinks.find((pack) => isActiveUrl(pack.url));

    if (activeLink?.count) {
      return activeLink.count;
    }

    const templatePackCount = getTemplatePackCount();

    if (templatePackCount) {
      return templatePackCount;
    }

    return selectedCount > 0 ? Math.min(Math.max(selectedCount, 2), 4) : 2;
  };

  const getOriginalSummary = () => appstleRoot?.querySelector('.ab-mix-and-match-summary-bar');

  const getQuantityFromProductItem = (item) => {
    const quantityInput = item.querySelector('input[type="number"], input[aria-label*="quantity" i], input[name*="quantity" i]');
    const inputValue = Number(quantityInput?.value || 0);

    if (inputValue > 0) {
      return inputValue;
    }

    const candidates = Array.from(item.querySelectorAll('span, div, button, input')).filter((node) => {
      const text = textOf(node);

      if (!/^\d+$/.test(text)) {
        return false;
      }

      if (node.closest('.ab-mix-and-match-product-title, .ab-mix-and-match-product-price-wrap')) {
        return false;
      }

      if (node.className && /price|title|discount|badge/i.test(String(node.className))) {
        return false;
      }

      const parentText = textOf(node.parentElement || node);
      const grandParentText = textOf(node.parentElement?.parentElement || node.parentElement || node);
      return /(\+|−|-|trash|delete|remove)/i.test(`${parentText} ${grandParentText}`)
        || node.matches('button')
        || node.closest('[class*="quantity" i], [class*="counter" i], [class*="qty" i]');
    });

    return candidates.reduce((highestQuantity, node) => {
      return Math.max(highestQuantity, Number(textOf(node)) || 0);
    }, 0);
  };

  const getSelectedProductsFromCards = () => {
    const selectedProducts = [];
    const productItems = Array.from(appstleRoot?.querySelectorAll('.ab-mix-and-match-product-item') || []);

    productItems.forEach((item) => {
      const quantity = getQuantityFromProductItem(item);

      if (quantity < 1) {
        return;
      }

      const imageNode = item.querySelector('.ab-mix-and-match-product-image');
      const titleNode = item.querySelector('.ab-mix-and-match-product-title');
      const priceNode = item.querySelector('.ab-mix-and-match-product-price');
      const cardNode = item.querySelector('.ab-mix-and-match-product-card');
      const handle = getProductItemHandle(item);
      const product = {
        image: getBackgroundImage(imageNode),
        title: textOf(titleNode),
        price: parseMoney(textOf(priceNode)),
        color: normalizeColor(item.dataset.bundleColor) || normalizeColor(cardNode?.style.backgroundColor),
        key: textOf(titleNode),
        handle
      };

      Array.from({ length: quantity }).forEach(() => {
        selectedProducts.push(product);
      });
    });

    return selectedProducts.filter((item) => item.image);
  };

  const getSelectedProductsFromSummary = () => {
    const summary = getOriginalSummary();
    const thumbnails = Array.from(summary?.querySelectorAll('.ab-mix-and-match-summary-thumbnails img, .ab-mix-and-match-summary-thumbnails [style*="background-image"]') || []);

    return thumbnails
      .map((item) => ({
        image: item.tagName === 'IMG' ? (item.currentSrc || item.src) : getBackgroundImage(item),
        title: item.getAttribute('alt') || item.getAttribute('title') || ''
      }))
      .filter((item) => item.image);
  };

  const getSelectedProducts = () => {
    const productsFromCards = getSelectedProductsFromCards();

    if (productsFromCards.length > 0) {
      return productsFromCards;
    }

    return getSelectedProductsFromSummary();
  };

  const isAddControl = (node) => {
    const control = node?.closest?.('button, [role="button"], input[type="button"], input[type="submit"]');

    if (!control || !appstleRoot?.contains(control)) {
      return false;
    }

    if (control.closest('.ab-byob-panel')) {
      return false;
    }

    if (control.closest('.ab-mix-and-match-subscription-block, .ab-volume-subscription-section')) {
      return false;
    }

    const productItem = control.closest('.ab-mix-and-match-product-item');

    if (!productItem) {
      return false;
    }

    const text = textOf(control);
    const className = String(control.className || '');
    const ariaLabel = control.getAttribute('aria-label') || '';

    return /add/i.test(text)
      || /\+/.test(text)
      || /add|plus|increment/i.test(`${className} ${ariaLabel}`);
  };

  const isPackFull = () => selectedItemsCount >= activePackLimit;

  const blockAddEvent = (event) => {
    if (!isPackFull() || !isAddControl(event.target)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  const syncAddControlsState = () => {
    if (!appstleRoot) {
      return;
    }

    const isFull = isPackFull();
    const controls = Array.from(appstleRoot.querySelectorAll('.ab-mix-and-match-product-item button, .ab-mix-and-match-product-item [role="button"], .ab-mix-and-match-product-item input[type="button"], .ab-mix-and-match-product-item input[type="submit"]'));

    controls.forEach((control) => {
      if (!isAddControl(control)) {
        return;
      }

      control.classList.toggle('ab-byob-add-disabled', isFull);
      control.setAttribute('aria-disabled', isFull ? 'true' : 'false');

      if ('disabled' in control) {
        control.disabled = isFull;
      }
    });

    appstleRoot.classList.toggle('ab-byob-pack-full', isFull);
  };

  const getActivePack = (selectedCount) => {
    if (selectedCount >= 4) {
      return 4;
    }

    if (selectedCount >= 3) {
      return 3;
    }

    return 2;
  };

  const getSubscriptionToggle = () => {
    return appstleRoot?.querySelector('.ab-mix-and-match-subscription-block .ab-volume-subscription-section')
      || appstleRoot?.querySelector('.ab-volume-subscription-section')
      || null;
  };

  const getSubscriptionDropdown = () => {
    return appstleRoot?.querySelector('#ab-volume-discount-variant-selector-select-dropdown')
      || appstleRoot?.querySelector('.ab-volume-subscription-dropdown')
      || appstleRoot?.querySelector('.ab-volume-discount-select-dropdown')
      || null;
  };

  const getDefaultSubscriptionOptionLabel = () => {
    const bodyClasses = Array.from(document.body?.classList || []);
    const templateClass = bodyClasses.find((className) => SUBSCRIPTION_DEFAULT_OPTIONS[className]);

    if (templateClass) {
      return SUBSCRIPTION_DEFAULT_OPTIONS[templateClass];
    }

    const path = window.location.pathname.replace(/\/$/, '').toLowerCase();

    if (path.includes('/products/2-pack')) {
      return SUBSCRIPTION_DEFAULT_OPTIONS['template-product-2-pack'];
    }

    if (path.includes('/products/3-pack')) {
      return SUBSCRIPTION_DEFAULT_OPTIONS['template-product-3-pack'];
    }

    if (path.includes('/products/4-pack')) {
      return SUBSCRIPTION_DEFAULT_OPTIONS['template-product-4-pack'];
    }

    return '';
  };

  const selectSubscriptionDropdownOption = () => {
    const select = getSubscriptionDropdown();
    const defaultLabel = getDefaultSubscriptionOptionLabel();

    if (!select || !defaultLabel) {
      return;
    }

    const normalizedDefaultLabel = defaultLabel.toLowerCase();
    const option = Array.from(select.options || []).find((item) => {
      const optionLabel = textOf(item).toLowerCase();

      return optionLabel === normalizedDefaultLabel
        || optionLabel.startsWith(`${normalizedDefaultLabel}(`)
        || optionLabel.startsWith(`${normalizedDefaultLabel} `)
        || optionLabel.includes(normalizedDefaultLabel);
    });

    if (!option || select.value === option.value) {
      return;
    }

    select.value = option.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const isSubscribeSelected = () => {
    const source = getSubscriptionToggle();

    if (!source) {
      return false;
    }

    const input = source.querySelector?.('input[type="checkbox"], input[type="radio"]');
    const ariaChecked = (source.getAttribute('aria-checked') || '').toLowerCase();
    const classList = Array.from(source.classList || []);
    const selectedClass = classList.some((className) => {
      const normalizedClass = String(className || '').toLowerCase();

      if (normalizedClass.includes('[') || normalizedClass.includes('var(')) {
        return false;
      }

      return [
        'active',
        'checked',
        'selected',
        'subscribed',
        'is-active',
        'is-checked',
        'is-selected',
        'ab-active',
        'ab-checked',
        'ab-selected'
      ].includes(normalizedClass);
    });

    return Boolean(input?.checked)
      || ariaChecked === 'true'
      || selectedClass;
  };

  const queueDefaultSubscriptionDropdownSync = (force = false) => {
    [0, 150, 400, 900].forEach((delay) => {
      window.setTimeout(() => {
        syncDefaultSubscriptionDropdown(force);
      }, delay);
    });
  };

  const syncDefaultSubscriptionDropdown = (force = false) => {
    const isSelected = isSubscribeSelected();

    if ((isSelected || force) && (force || !wasSubscribeSelected)) {
      selectSubscriptionDropdownOption();
    }

    wasSubscribeSelected = isSelected;
  };

  const getPackDiscount = (packCount) => {
    const pack = PACKS.find((item) => item.count === packCount);
    const discount = pack?.badge?.match(/\d+/);

    return discount ? Number(discount[0]) : 0;
  };

  const getBundleSubscriptionPlanLabel = (packCount) => {
    const discount = getPackDiscount(packCount);

    return discount ? `bundle ${discount}` : '';
  };

  const getChoicePriceHtml = (currentPrice, originalPrice) => {
    if (!currentPrice || !originalPrice) {
      return '';
    }

    return `
      <span class="ab-byob-panel__choice-price">
        <span>${escapeHtml(currentPrice)}</span>
        <s>${escapeHtml(originalPrice)}</s>
      </span>
    `;
  };

  const clickSubscription = () => {
    const toggle = getSubscriptionToggle();

    if (!toggle) {
      return;
    }

    const clickTarget = toggle.querySelector('.ab-volume-subscription-checkbox-container')
      || toggle.querySelector('.ab-volume-subscription-container')
      || toggle;

    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach((eventName) => {
      const EventConstructor = eventName.startsWith('pointer') && window.PointerEvent
        ? window.PointerEvent
        : window.MouseEvent;

      clickTarget.dispatchEvent(new EventConstructor(eventName, { bubbles: true, cancelable: true, view: window }));
    });

    queueDefaultSubscriptionDropdownSync(true);
  };

  const clickAddToCart = () => {
    appstleRoot?.querySelector('.ab-mix-and-match-add-to-cart-button')?.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );
  };

  const fetchProductJson = async (handle) => {
    if (!handle) {
      throw new Error('Missing product handle for subscription bundle item.');
    }

    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`Unable to load product data for ${handle}.`);
    }

    return response.json();
  };

  const findSubscriptionSellingPlanId = (product, packCount) => {
    const planLabel = getBundleSubscriptionPlanLabel(packCount).toLowerCase();
    const planGroups = product?.selling_plan_groups || [];

    for (const group of planGroups) {
      const isAppstleGroup = String(group?.app_id || '').toLowerCase() === 'appstle'
        || String(group?.name || '').toLowerCase().includes('bundle');

      if (!isAppstleGroup) {
        continue;
      }

      const plan = (group.selling_plans || []).find((item) => {
        const name = String(item?.name || '').toLowerCase();

        return name === planLabel
          || name.startsWith(`${planLabel}(`)
          || name.startsWith(`${planLabel} `)
          || name.includes(planLabel);
      });

      if (plan?.id) {
        return plan.id;
      }
    }

    return null;
  };

  const getAvailableVariantId = (product) => {
    const variant = (product?.variants || []).find((item) => item.available) || product?.variants?.[0];

    return variant?.id || null;
  };

  const addSubscriptionBundleToCart = async () => {
    const selectedProducts = getSelectedProducts().slice(0, activePackLimit);
    const groupedProducts = new Map();

    selectedProducts.forEach((product) => {
      if (!product.handle) {
        return;
      }

      groupedProducts.set(product.handle, (groupedProducts.get(product.handle) || 0) + 1);
    });

    const items = [];

    for (const [handle, quantity] of groupedProducts.entries()) {
      const product = await fetchProductJson(handle);
      const variantId = getAvailableVariantId(product);
      const sellingPlanId = findSubscriptionSellingPlanId(product, activePackLimit);

      if (!variantId || !sellingPlanId) {
        throw new Error(`Missing subscription selling plan for ${handle}.`);
      }

      items.push({
        id: variantId,
        quantity,
        selling_plan: sellingPlanId,
        properties: {
          _bundle_pack: `${activePackLimit} Pack`
        }
      });
    }

    if (items.length !== selectedProducts.length && groupedProducts.size !== selectedProducts.length) {
      const selectedQuantity = selectedProducts.length;
      const itemQuantity = items.reduce((total, item) => total + item.quantity, 0);

      if (itemQuantity !== selectedQuantity) {
        throw new Error('Unable to prepare all subscription bundle items.');
      }
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error('Unable to add subscription bundle to cart.');
    }

    return response.json();
  };

  const refreshCartUi = () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    window.setTimeout(() => {
      window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
    }, 250);
  };

  const getOneTimeDiscountCode = () => {
    return String(oneTimeDiscountCodes?.[activePackLimit] || '').trim();
  };

  const applyOneTimeDiscountCode = async () => {
    const discountCode = getOneTimeDiscountCode();

    if (!discountCode) {
      return;
    }

    const routesRoot = window.Shopify?.routes?.root || '/';
    const rootPath = routesRoot.endsWith('/') ? routesRoot : `${routesRoot}/`;
    const discountUrl = `${rootPath}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(window.location.pathname)}`;

    await fetch(discountUrl, {
      credentials: 'same-origin',
      redirect: 'follow'
    });
  };

  const setCtaLoading = (button, isLoading) => {
    if (!button) {
      return;
    }

    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading || selectedItemsCount < activePackLimit;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const isRemoveControl = (control) => {
    const text = textOf(control);
    const className = String(control?.className || '');
    const ariaLabel = control?.getAttribute?.('aria-label') || '';
    const title = control?.getAttribute?.('title') || '';

    return /remove|delete|trash|minus|decrement/i.test(`${text} ${className} ${ariaLabel} ${title}`)
      || /^[-−]$/.test(text);
  };

  const clickRemoveProduct = (productTitle) => {
    const productItems = Array.from(appstleRoot?.querySelectorAll('.ab-mix-and-match-product-item') || []);
    const productItem = productItems.find((item) => {
      return textOf(item.querySelector('.ab-mix-and-match-product-title')) === productTitle;
    });

    if (!productItem) {
      return;
    }

    const controls = Array.from(productItem.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"]'));
    const removeControl = controls.find(isRemoveControl);

    if (removeControl) {
      removeControl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }
  };

  const createPanel = () => {
    panel = document.createElement('aside');
    panel.className = 'ab-byob-panel';
    appstleRoot.append(panel);
  };

  const getAvailableCatalogues = () => {
    if (catalogueTabs.length) {
      return catalogueTabs.filter(Boolean);
    }

    const labels = [];
    appstleRoot?.querySelectorAll('.ab-mix-and-match-product-item[data-catalogue]').forEach((item) => {
      const label = item.dataset.catalogue || '';

      if (label && !labels.includes(label)) {
        labels.push(label);
      }
    });

    return labels;
  };

  const applyCatalogueFilter = () => {
    if (!appstleRoot) {
      return;
    }

    appstleRoot.querySelectorAll('.ab-mix-and-match-product-item').forEach((item) => {
      const title = item.querySelector('.ab-mix-and-match-product-title');
      const catalogueLabel = title?.getAttribute('data-catalogue-label') || item.dataset.catalogue || '';
      const catalogueValue = normalizeFilterValue(catalogueLabel);
      const searchValue = (item.dataset.searchText || textOf(item.querySelector('.ab-mix-and-match-product-title'))).toLowerCase();
      const matchesCatalogue = activeCatalogueFilter === 'all' || catalogueValue === activeCatalogueFilter;
      const matchesSearch = !activeSearchTerm || searchValue.includes(activeSearchTerm);

      item.hidden = !(matchesCatalogue && matchesSearch);
    });

    toolbar?.querySelectorAll('.ab-byob-toolbar__tab').forEach((button) => {
      const isActive = button.dataset.filter === activeCatalogueFilter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    toolbar?.querySelectorAll('.ab-byob-toolbar__more-item').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.filter === activeCatalogueFilter);
    });

    const moreToggle = toolbar?.querySelector('.ab-byob-toolbar__more-toggle');
    const activeMoreItem = toolbar?.querySelector(`.ab-byob-toolbar__more-item[data-filter="${activeCatalogueFilter}"]`);

    if (moreToggle) {
      const label = moreToggle.querySelector('.ab-byob-toolbar__more-label');

      moreToggle.classList.toggle('is-active', Boolean(activeMoreItem));

      if (label) {
        label.textContent = activeMoreItem ? textOf(activeMoreItem) : 'More';
      }
    }
  };

  const bindToolbarEvents = () => {
    toolbar.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        activeCatalogueFilter = button.dataset.filter || 'all';
        toolbar.querySelector('.ab-byob-toolbar__more')?.classList.remove('is-open');
        toolbar.querySelector('.ab-byob-toolbar__more-toggle')?.setAttribute('aria-expanded', 'false');
        applyCatalogueFilter();
      });
    });

    toolbar.querySelector('.ab-byob-toolbar__search input')?.addEventListener('input', (event) => {
      activeSearchTerm = event.target.value.trim().toLowerCase();
      applyCatalogueFilter();
    });

    toolbar.querySelector('.ab-byob-toolbar__more-toggle')?.addEventListener('click', (event) => {
      event.stopPropagation();
      const more = toolbar.querySelector('.ab-byob-toolbar__more');
      const isOpen = more?.classList.toggle('is-open');
      event.currentTarget.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  };

  const renderCatalogueTabs = () => {
    if (!toolbar) {
      return;
    }

    const labels = getAvailableCatalogues();
    const signature = labels.join('|');
    const primaryLabels = labels.slice(0, 2);
    const overflowLabels = labels.slice(2);
    const knownFilters = new Set(['all', ...labels.map(normalizeFilterValue)]);

    if (!knownFilters.has(activeCatalogueFilter)) {
      activeCatalogueFilter = 'all';
    }

    if (catalogueToolbarSignature === signature && toolbar.querySelector('.ab-byob-toolbar__tabs')) {
      applyCatalogueFilter();
      return;
    }

    catalogueToolbarSignature = signature;

    toolbar.innerHTML = `
      <div class="ab-byob-toolbar__tabs">
        <button type="button" class="ab-byob-toolbar__tab" data-filter="all" aria-pressed="true">All</button>
        ${primaryLabels.map((label) => `
          <button type="button" class="ab-byob-toolbar__tab" data-filter="${escapeHtml(normalizeFilterValue(label))}" aria-pressed="false">${escapeHtml(label)}</button>
        `).join('')}
        ${overflowLabels.length ? `
          <div class="ab-byob-toolbar__more">
            <button type="button" class="ab-byob-toolbar__more-toggle" aria-expanded="false">
              <span class="ab-byob-toolbar__more-label">More</span>
              <span class="ab-byob-toolbar__more-icon" aria-hidden="true"></span>
            </button>
            <div class="ab-byob-toolbar__more-menu">
              ${overflowLabels.map((label) => `
                <button type="button" class="ab-byob-toolbar__more-item" data-filter="${escapeHtml(normalizeFilterValue(label))}">${escapeHtml(label)}</button>
              `).join('')}
            </div>
          </div>
        ` : ''}
      </div>
      <label class="ab-byob-toolbar__search">
        <span class="visually-hidden">Search products</span>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1539 12.2073L10.6806 9.75393C11.6407 8.55687 12.1056 7.03747 11.9798 5.50813C11.854 3.9788 11.147 2.55579 10.0043 1.5317C8.86151 0.507604 7.3698 -0.0397263 5.83588 0.00224731C4.30196 0.0442209 2.84241 0.672308 1.75736 1.75736C0.672308 2.84241 0.0442209 4.30196 0.00224731 5.83588C-0.0397263 7.3698 0.507604 8.86151 1.5317 10.0043C2.55579 11.147 3.9788 11.854 5.50813 11.9798C7.03747 12.1056 8.55687 11.6407 9.75393 10.6806L12.2073 13.1339C12.2692 13.1964 12.343 13.246 12.4242 13.2799C12.5055 13.3137 12.5926 13.3311 12.6806 13.3311C12.7686 13.3311 12.8557 13.3137 12.937 13.2799C13.0182 13.246 13.092 13.1964 13.1539 13.1339C13.2741 13.0096 13.3413 12.8435 13.3413 12.6706C13.3413 12.4977 13.2741 12.3316 13.1539 12.2073ZM6.01393 10.6806C5.09095 10.6806 4.1887 10.4069 3.42127 9.89412C2.65384 9.38134 2.0557 8.65251 1.7025 7.79979C1.34929 6.94707 1.25687 6.00876 1.43694 5.10351C1.617 4.19827 2.06146 3.36675 2.7141 2.7141C3.36675 2.06146 4.19827 1.617 5.10351 1.43694C6.00876 1.25687 6.94707 1.34929 7.79979 1.7025C8.65251 2.0557 9.38134 2.65384 9.89412 3.42127C10.4069 4.1887 10.6806 5.09095 10.6806 6.01393C10.6806 7.25161 10.1889 8.43859 9.31376 9.31376C8.43859 10.1889 7.25161 10.6806 6.01393 10.6806Z" fill="#1D1D1D"/></svg>
          <input type="search" placeholder="Search for..." value="${escapeHtml(activeSearchTerm)}">
      </label>
    `;

    bindToolbarEvents();
    applyCatalogueFilter();
  };

  const createToolbar = () => {
    if (toolbar) {
      return;
    }

    const productsContainer = appstleRoot.querySelector('.ab-mix-and-match-products-container');

    if (!productsContainer) {
      return;
    }

    toolbar = document.createElement('div');
    toolbar.className = 'ab-byob-toolbar';

    productsContainer.insertAdjacentElement('beforebegin', toolbar);
    renderCatalogueTabs();

    if (!appstleRoot.dataset.abByobToolbarOutsideClickBound) {
      appstleRoot.dataset.abByobToolbarOutsideClickBound = 'true';

      document.addEventListener('click', (event) => {
        const more = toolbar?.querySelector('.ab-byob-toolbar__more.is-open');

        if (!more || more.contains(event.target)) {
          return;
        }

        more.classList.remove('is-open');
        toolbar?.querySelector('.ab-byob-toolbar__more-toggle')?.setAttribute('aria-expanded', 'false');
      });
    }
  };

  const renderPanel = () => {
    if (!appstleRoot) {
      return;
    }

    isRendering = true;

    if (!panel) {
      createPanel();
    }

    const products = getSelectedProducts();
    const bundlePackLinks = getBundlePackLinks();
    const activePack = getActivePackCount(products.length, bundlePackLinks);
    const selectedCount = Math.min(products.length, activePack);
    const visibleProducts = products.slice(0, activePack);
    const isComplete = products.length >= activePack;
    const selectedProductsSignature = visibleProducts
      .map((product) => `${product.title}|${product.image}`)
      .join('||');

    if (!isComplete) {
      if (purchaseMode === 'subscribe') {
        clickSubscription();
      }

      purchaseMode = 'onetime';
      frozenChoicePrices = null;
      pendingChoicePrices = null;

      if (choicePriceTimer) {
        window.clearTimeout(choicePriceTimer);
        choicePriceTimer = null;
      }
    } else if (
      !frozenChoicePrices
      || frozenChoicePrices.pack !== activePack
      || frozenChoicePrices.signature !== selectedProductsSignature
    ) {
      const stableOriginalTotal = visibleProducts.reduce((total, product) => {
        return total + getStableProductPrice(product);
      }, 0);
      const originalPrice = formatMoney(stableOriginalTotal);
      const onetimeChoicePrice = formatMoney(stableOriginalTotal - ONE_TIME_DISCOUNT_AMOUNT);
      const subscribeChoicePrice = formatMoney(stableOriginalTotal * (1 - getPackDiscount(activePack) / 100));

      pendingChoicePrices = {
        pack: activePack,
        signature: selectedProductsSignature,
        original: originalPrice,
        onetime: onetimeChoicePrice,
        subscribe: subscribeChoicePrice
      };

      if (!choicePriceTimer) {
        choicePriceTimer = window.setTimeout(() => {
          frozenChoicePrices = pendingChoicePrices;
          pendingChoicePrices = null;
          choicePriceTimer = null;
          renderPanel();
        }, 250);
      }
    }

    const choicePrices = frozenChoicePrices || pendingChoicePrices;
    const originalPrice = choicePrices?.original || '';
    const visualSubscribe = purchaseMode === 'subscribe';
    const onetimeChoicePrice = choicePrices?.onetime || '';
    const subscribeChoicePrice = choicePrices?.subscribe || '';
    const selectedChoicePrice = visualSubscribe ? subscribeChoicePrice : onetimeChoicePrice;
    const packBadgeText = (pack) => visualSubscribe ? pack.badge : 'Save 10$';
    const subscriptionBenefits = visualSubscribe
      ? `
        <div class="ab-byob-panel__benefits">
          <div class="ab-byob-panel__benefit">Earn <strong>loyalty points</strong><br>for coupons & discounts</div>
          <div class="ab-byob-panel__benefit">Pause, update frequency<br>or <strong>cancel anytime</strong></div>
        </div>
        <p class="ab-byob-panel__note">Always have your favorite supplements on hand.</p>
      `
      : '';
    activePackLimit = activePack;
    selectedItemsCount = products.length;

    panel.dataset.pack = String(activePack);

    const slots = Array.from({ length: activePack }).map((_, index) => {
      const product = visibleProducts[index];

      if (product?.image) {
        const slotStyle = product.color ? ` style="background-color: ${escapeHtml(product.color)};"` : '';

        return `
          <div class="ab-byob-panel__slot"${slotStyle}>
            <button type="button" class="ab-byob-panel__remove" aria-label="Remove ${escapeHtml(product.title)}" data-remove-title="${escapeHtml(product.title)}"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="13" fill="#236D37"/><path d="M17.0655 18.4543L12.8906 14.2794L8.71578 18.4543L7.32416 17.0626L11.499 12.8878L7.32416 8.71295L8.71578 7.32133L12.8906 11.4962L17.0655 7.32133L18.4571 8.71295L14.2822 12.8878L18.4571 17.0626L17.0655 18.4543Z" fill="white"/></svg></button>
            <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}">
          </div>
        `;
      }

      return '<div class="ab-byob-panel__slot"></div>';
    }).join('');

    panel.innerHTML = `
      <h2 class="ab-byob-panel__title">Your Bundle ${selectedCount} / ${activePack}</h2>
      <div class="ab-byob-panel__packs">
        ${bundlePackLinks.map((pack) => `
          <a href="${escapeHtml(pack.url)}" class="ab-byob-panel__pack${isActiveUrl(pack.url) ? ' is-active' : ''}" data-pack="${pack.count}">
            <span class="ab-byob-panel__badge">${escapeHtml(packBadgeText(pack))}</span>
            ${pack.label}
          </a>
        `).join('')}
      </div>
      <div class="ab-byob-panel__slots">${slots}</div>
      <p class="ab-byob-panel__frequency">Frequency:</p>
      <button type="button" class="ab-byob-panel__choice${!visualSubscribe ? ' is-active' : ''}" data-purchase="onetime">
        <span class="ab-byob-panel__choice-label">
          <span class="ab-byob-panel__radio"></span>
          One-Time Purchase
        </span>
        ${getChoicePriceHtml(onetimeChoicePrice, originalPrice)}
      </button>
      <button type="button" class="ab-byob-panel__choice${visualSubscribe ? ' is-active' : ''}" data-purchase="subscribe">
        <span class="ab-byob-panel__choice-label">
          <span class="ab-byob-panel__radio"></span>
          Subscribe & Save Bundle
        </span>
        ${getChoicePriceHtml(subscribeChoicePrice, originalPrice)}
      </button>
      ${subscriptionBenefits}
      <button type="button" class="ab-byob-panel__cta"${products.length < activePack ? ' disabled' : ''}>${products.length >= activePack && selectedChoicePrice ? `${selectedChoicePrice} - ADD TO BAG` : 'ADD TO BAG'}</button>
    `;

    panel.querySelector('[data-purchase="subscribe"]')?.addEventListener('click', () => {
      if (purchaseMode !== 'subscribe') {
        clickSubscription();
      } else {
        syncDefaultSubscriptionDropdown(true);
      }

      purchaseMode = 'subscribe';
      window.setTimeout(renderPanel, 250);
    });

    panel.querySelector('[data-purchase="onetime"]')?.addEventListener('click', () => {
      if (purchaseMode !== 'onetime') {
        clickSubscription();
      }

      purchaseMode = 'onetime';
      window.setTimeout(renderPanel, 250);
    });

    panel.querySelector('.ab-byob-panel__cta')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;

      if (button.disabled || button.classList.contains('is-loading')) {
        return;
      }

      setCtaLoading(button, true);

      try {
        if (purchaseMode !== 'onetime') {
          await addSubscriptionBundleToCart();
          refreshCartUi();
          return;
        }

        await applyOneTimeDiscountCode();
        clickAddToCart();
      } catch (error) {
        console.warn('Unable to add custom bundle from panel.', error);
        clickAddToCart();
      } finally {
        window.setTimeout(() => {
          setCtaLoading(button, false);
        }, 900);
      }
    });

    panel.querySelectorAll('.ab-byob-panel__remove').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        clickRemoveProduct(event.currentTarget.dataset.removeTitle || '');
      });
    });

    syncAddControlsState();
    syncDefaultSubscriptionDropdown();
    window.requestAnimationFrame(() => {
      isRendering = false;
    });
  };

  const init = () => {
    if (appstleRoot) {
      return true;
    }

    appstleRoot = findRoot();

    if (!appstleRoot) {
      return false;
    }

    appstleRoot.classList.add('ab-byob-skinned');
    createToolbar();
    syncProductRatings();
    renderPanel();

    appstleRoot.addEventListener('click', blockAddEvent, true);
    appstleRoot.addEventListener('pointerdown', blockAddEvent, true);
    appstleRoot.addEventListener('mousedown', blockAddEvent, true);
    appstleRoot.addEventListener('click', (event) => {
      if (!event.target?.closest?.('.ab-volume-subscription-section')) {
        return;
      }

      if (event.target?.closest?.('.ab-volume-discount-select-dropdown-wrapper, select')) {
        return;
      }

      queueDefaultSubscriptionDropdownSync(true);
    }, true);
    appstleRoot.addEventListener('change', (event) => {
      if (!event.target?.closest?.('.ab-volume-subscription-section')) {
        return;
      }

      if (!event.target?.closest?.('select')) {
        queueDefaultSubscriptionDropdownSync(true);
      }
    }, true);

    observer = new MutationObserver((mutations) => {
      const isRatingMutation = (mutation) => {
        const nodes = [...Array.from(mutation.addedNodes), ...Array.from(mutation.removedNodes)];

        return nodes.length > 0 && nodes.every((node) => {
          return node instanceof HTMLElement
            && (
              node.classList.contains('ab-byob-product-rating')
              || Boolean(node.closest('.ab-byob-product-rating'))
            );
        });
      };

      if (
        isRendering
        || isSyncingRatings
        || mutations.every((mutation) => panel?.contains(mutation.target) || mutation.target?.closest?.('.ab-byob-product-rating') || isRatingMutation(mutation))
      ) {
        return;
      }

      window.requestAnimationFrame(() => {
        syncProductRatings();
        renderPanel();
        syncDefaultSubscriptionDropdown();
      });
    });

    observer.observe(appstleRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'disabled']
    });

    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const bootObserver = new MutationObserver(() => {
    if (init()) {
      bootObserver.disconnect();
    }
  });

  bootObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(() => {
    bootObserver.disconnect();

    if (!appstleRoot && observer) {
      observer.disconnect();
    }
  }, 30000);
})();
